import blogStyles from './blog-styles';
import chartComparisonTableStyles from './chart-comparison-table-styles';
import htmlParserStyles from './html-parser';
import paragraphNestedLinkStyles from './paragraph-nested-link-styles';

const sharedStyles = {
  blogStyles,
  chartComparisonTableStyles,
  htmlParserStyles,
  paragraphNestedLinkStyles,
};

export default sharedStyles;
